import $ from 'jquery'
import { isOffline } from './offline/offline'

import Delete from './tool/Delete'
import Copy from './tool/Copy'
import Deselect from './tool/Deselect'
import Draw from './tool/Draw'
import Measure from './tool/Measure'
import Modify from './tool/Modify'
import Coordinate from './tool/Coordinate'
import Print from './tool/Print'
import Text from './tool/Text'
import gpsLocationMarker from './gpsLocationMarker'
import Tools from './Tools'
import BufferedLine from './tool/BufferedLine'
import isObject from 'lodash/isObject'

/**
 * Toolbar class
 *
 * @param {Object} config
 * @constructor
 */
export default function Toolbar(config) {
  $.extend(this, config)
  // NOTE: dynamic UI not done yet
  // this.ui = new olga.ui.Toolbar(config)

  // NOTE: dynamic tool logic, not finished
  // this.tools = this.config.tools.map(this.createTool, this)

  this.measureLine = new Measure({
    toolbar: this,
    map: this.map,
    geometryType: 'LineString'
  })

  this.measureArea = new Measure({
    toolbar: this,
    map: this.map,
    geometryType: 'Polygon'
  })

  this.print = new Print({
    map: this.map,
    config: this.config.print
  })

  this.drawPoint = new Draw({
    map: this.map,
    type: 'Point',
    api: this.api
  })

  this.drawLine = new Draw({
    map: this.map,
    type: 'LineString',
    api: this.api
  })

  this.drawPolygon = new Draw({
    map: this.map,
    type: 'Polygon',
    api: this.api
  })

  this.drawBufferedLine = new BufferedLine({
    map: this.map,
    api: this.api,
    options:
      this.config.toolbar && Array.isArray(this.config.toolbar.drawtools)
        ? this.config.toolbar.drawtools
            .filter(isObject)
            .find(tool => tool.type === Tools.BUFFERED_LINE)
        : undefined
  })

  this.texttool = new Text({
    map: this.map
  })

  this.modify = new Modify({
    map: this.map,
    select: this.select,
    texttool: this.texttool,
    api: this.api
  })

  this.coordinate = new Coordinate({
    map: this.map,
    config: this.config
  })

  this.deselect = new Deselect({
    map: this.map,
    select: this.select
  })

  this.copy = new Copy({
    map: this.map,
    api: this.api,
    config: this.config
  })

  this.delete_ = new Delete({
    map: this.map,
    api: this.api
  })

  this.drawToolDefinitions = {
    [Tools.POINT]: {
      id: 'drawPoint',
      icon: 'fa fa-circle-o',
      title: 'Punkt',
      tool: this.drawPoint,
      type: 'create'
    },
    [Tools.LINE]: {
      id: 'drawLine',
      icon: 'map-line',
      title: 'Linje',
      tool: this.drawLine,
      type: 'create'
    },
    [Tools.POLYGON]: {
      id: 'drawPolygon',
      icon: 'map-polygon',
      title: 'Yta',
      tool: this.drawPolygon,
      type: 'create'
    },
    [Tools.BUFFERED_LINE]: {
      id: 'drawBufferedLine',
      icon: 'map-line',
      title: 'Buffrad Linje',
      tool: this.drawBufferedLine,
      type: 'create'
    },
    [Tools.TEXT]: {
      id: 'drawText',
      icon: 'map-text',
      title: 'Text',
      tool: this.texttool,
      type: 'create'
    },
    [Tools.MODIFY]: {
      id: 'modify',
      icon: 'fa fa-edit',
      title: 'Ändra',
      tool: this.modify,
      type: 'modify'
    },
    [Tools.DELETE]: {
      id: 'delete',
      icon: 'fa fa-times',
      title: 'Ta bort',
      tool: this.delete_,
      type: 'modify'
    },
    [Tools.COPY]: {
      id: 'copy',
      icon: 'fa fa-copy',
      title: 'Kopiera',
      tool: this.copy,
      type: 'create'
    }
  }

  this.customToolsDefinitions = {}

  let activeDrawTools = [
    Tools.POINT,
    Tools.LINE,
    Tools.POLYGON,
    Tools.TEXT,
    Tools.MODIFY,
    Tools.DELETE
  ]

  if (!this.config.toolbar || !this.config.toolbar.drawtools) {
    activeDrawTools = []
  } else if (Array.isArray(this.config.toolbar.drawtools)) {
    activeDrawTools = this.config.toolbar.drawtools
  }

  if (activeDrawTools.length > 0) {
    this.addLabel('Rita & Skriv')
    let createToolsConfigs = activeDrawTools
      .map(tool => this.getDrawToolDefinition(tool))
      .filter(config => config && config.type === 'create')

    let modifyToolsConfigs = activeDrawTools
      .map(tool => this.getDrawToolDefinition(tool))
      .filter(config => config && config.type === 'modify')

    createToolsConfigs.forEach(config => this.addTool(config))

    if (modifyToolsConfigs.length > 0 && createToolsConfigs.length > 0) {
      this.addSeparator()
    }
    modifyToolsConfigs.forEach(config => this.addTool(config))
    this.addSeparator('digitizing-select')
  }

  this.addTool({
    id: 'select',
    icon: 'fa fa-check-square-o',
    title: 'Markera objekt',
    tool: this.api.select,
    classname: 'digitizing-select'
  })

  this.activeTool = null

  this.$toolbarDropup = $('#tools-dropup')

  // NOTE: static tool logic, used until dynamic tools is needed/completed

  if (this.config.toolbar && this.config.toolbar.drawtools) {
    $('.digitizing').removeClass('hide')
  }

  this.$toolbarDropup.on('click', e => {
    if ($(e.target).closest('.dropdown-toggle').length) {
      this.$toolbarDropup.toggleClass('open')
    } else {
      this.$toolbarDropup.removeClass('open')
    }
  })

  // Create trigger functions of event listeners
  this.eventTrigger = this.api.toolbar.createTrigger()

  this.gps = gpsLocationMarker(this)
  $('#deselectToggle').on('click', this.deselect, $.proxy(this.toggle, this))
  $('#toolsDisable').on('click', $.proxy(this.deactivateActiveTool, this))
  $('#lineToggle').on('click', this.measureLine, $.proxy(this.toggle, this))
  $('#coordinate').on('click', this.coordinate, $.proxy(this.toggle, this))
  $('#polygonToggle').on('click', this.measureArea, $.proxy(this.toggle, this))

  $('#gpsToggle').on('click', this.gps.toggle)
}

Toolbar.prototype.getDrawToolDefinition = function(tool) {
  if (isObject(tool)) {
    return Object.assign({}, this.drawToolDefinitions[tool.type], {
      options: tool.options
    })
  } else {
    return this.drawToolDefinitions[tool]
  }
}

Toolbar.prototype.toggle = function(event) {
  const tool = event.data

  this.toggleTool(tool, $(event.target))
}

Toolbar.prototype.toggleTool = function(tool, toolElement) {
  if (tool.disableOffline && isOffline) return

  this.removeActiveClass()

  if (tool.enableToggle) {
    if (tool === this.activeTool) {
      this.deactivateActiveTool()
    } else {
      this.deactivateActiveTool()
      this.activateTool(tool)

      var $li = toolElement.closest('li')
      this.addActiveClass($li)
    }
  } else {
    tool.activate()
    this.sendEvent('activate', tool)
  }
}

Toolbar.prototype.deactivateActiveTool = function() {
  if (this.activeTool) {
    this.removeActiveClass()

    // Hack needed for AutoSelection conditionalToggle to work
    var tool = this.activeTool
    this.activeTool = null
    tool.deactivate()
    this.sendEvent('deactivate', tool)
  }
}

Toolbar.prototype.activateTool = function(tool) {
  // Hack needed for AutoSelection conditionalToggle to work
  this.activeTool = tool
  tool.activate()
  this.sendEvent('activate', tool)
}

Toolbar.prototype.addActiveClass = function($target) {
  $target.addClass('active')
}

Toolbar.prototype.removeActiveClass = function() {
  $('#navbarSouth .dropdown-menu')
    .find('li')
    .removeClass('active')
}

Toolbar.prototype.addLabel = function(label) {
  const toolElement = $(`
    <li class="dropdown-header digitizing hide">${label}</li>
  `)

  $('#navbarSouth .dropdown-menu').append(toolElement)
}

Toolbar.prototype.addSeparator = function(classname = 'digitizing') {
  const toolElement = $(`
    <li class="divider ${classname} hide"></li>
  `)
  $('#navbarSouth .dropdown-menu').append(toolElement)
}

/**
 * Dynamically add a tool definition. This replaces the old addCustomTool
 */

Toolbar.prototype.addTool = function(config) {
  config = config || {}
  const classname = config.classname || 'digitizing'
  const toolElement = $(`
    <li class="${classname} hide"><a id="${config.id}Toggle"><i class="${config.icon}"></i> ${config.title}</a></li>
  `)
  if (config.icon) {
    config.tool.ui.iconClass = config.icon
  }
  toolElement.on('click', config.tool, $.proxy(this.toggle, this))
  $('#navbarSouth .dropdown-menu').append(toolElement)

  if (!(config.id in this.drawToolDefinitions)) {
    this.customToolsDefinitions = Object.assign(this.customToolsDefinitions, {
      [config.id]: Object.assign({}, config)
    })
  }
}

Toolbar.prototype.activateToolByName = function(toolName) {
  const toolDefinition = this.drawToolDefinitions[toolName]
  if (!toolDefinition) {
    const customToolDefinition = this.customToolsDefinitions[toolName]
    if (!customToolDefinition) {
      console.warn(`Tool ${toolName} not available`)
      return
    }
    this.toggleTool(
      customToolDefinition.tool,
      $(`#${customToolDefinition.id}Toggle`)
    )
    return
  }
  this.toggleTool(toolDefinition.tool, $(`#${toolDefinition.id}Toggle`))
}

Toolbar.prototype.showToolByName = function(toolName) {
  const toolDefinition = this.drawToolDefinitions[toolName]
  if (!toolDefinition) {
    const customToolDefinition = this.customToolsDefinitions[toolName]
    if (!customToolDefinition) {
      console.warn(`Tool ${toolName} not available`)
      return
    }
    $(`#${customToolDefinition.id}Toggle`)
      .closest('li')
      .removeClass('hide')
    return
  }
  $(`#${toolDefinition.id}Toggle`)
    .closest('li')
    .removeClass('hide')
}

Toolbar.prototype.hideToolByName = function(toolName) {
  const toolDefinition = this.drawToolDefinitions[toolName]
  if (!toolDefinition) {
    const customToolDefinition = this.customToolsDefinitions[toolName]
    if (!customToolDefinition) {
      console.warn(`Tool ${toolName} not available`)
      return
    }
    $(`#${customToolDefinition.id}Toggle`)
      .closest('li')
      .addClass('hide')
    return
  }

  $(`#${toolDefinition.id}Toggle`)
    .closest('li')
    .addClass('hide')
}
Toolbar.prototype.changeActiveToolIcon = function(iconClass) {
  $('#navbarSouth .dropdown-toggle')
    .find('i')
    .removeClass()
    .addClass(iconClass)
}
Toolbar.prototype.getToolId = function(tool) {
  return Object.keys(this.drawToolDefinitions).find(
    toolKey => this.drawToolDefinitions[toolKey].tool === tool
  )
}

Toolbar.prototype.sendEvent = function(eventType, tool) {
  const toolId = this.getToolId(tool)
  if (!toolId) {
    return
  }
  this.eventTrigger({ type: eventType, tool: toolId })
}
/**
 * User is responsible to remove callbacks related to it.
 * This just removes it from definitions and UI
 * @param {string} toolName
 */
Toolbar.prototype.removeCustomTool = function(toolName) {
  const customToolDefinition = this.customToolsDefinitions[toolName]
  if (!customToolDefinition) {
    console.warn(`Tool ${toolName} does not exist`)
    return
  }
  if (!toolName) {
    console.warn(`Toolname must be provided`)
  }
  delete this.customToolsDefinitions[toolName]
  $(`#${toolName}Toggle`)
    .closest('li')[0]
    .remove()
}
